module.exports = "/_next/static/images/19ee63dab86c81076433015a8537617e-apple-pay.png.webp";